import initLocale from '../etc/localize'
import { isTabletOrMobile } from '../kit'
import axios from 'axios'

/*
/*
/*        R E D U C E R
/*
/*
*/

import { LOCATION_CHANGE } from 'react-router-redux'
import { GET_MATERIALS_KINDS, GET_PROJECTS_AREAS } from './data'
// import Superface from '../Superface';
export const SET_SECTION = 'app/SET_SECTION'
export const SET_LANG = 'app/SET_LANG'
export const SET_NEXT_SECTION = 'app/SET_NEXT_SECTION'
export const TOGGLE_LOADING = 'app/TOGGLE_LOADING'
export const SET_COMPASS = 'app/SET_COMPASS'
export const SET_COMPASS_HIDDEN_ON_MOBILE = 'app/SET_COMPASS_HIDDEN_ON_MOBILE'
export const TOGGLE_MENU = 'app/TOGGLE_MENU'
export const SET_LOADING = 'app/SET_LOADING'
export const SINGLE_LEAVING = 'app/SINGLE_LEAVING'
export const MAP_LEAVING = 'app/MAP_LEAVING'
export const GET_IP = 'app/GET_IP'

export const APP_LOADED = 'app/APP_LOADED'

// Materials
export const TOGGLE_KIND_FILTER = 'app/TOGGLE_KIND_FILTER'
export const TOGGLE_AREA_FILTER = 'app/TOGGLE_AREA_FILTER'
export const SET_KIND_TITLE = 'app/SET_KIND_TITLE'
export const SET_MATERIALS_GRID_ACTIVE = 'app/SET_MATERIALS_GRID_ACTIVE'
export const SET_PROJECTS_GRID_ACTIVE = 'app/SET_PROJECTS_GRID_ACTIVE'
export const SET_PROJECTS_VIEW_MODE = 'app/SET_PROJECTS_VIEW_MODE'
export const SET_CURRENT_TL_PROJECT_INDEX = 'app/SET_CURRENT_TL_PROJECT_INDEX'
export const SET_KIND_FEATURED_IMAGE = 'app/SET_KIND_FEATURED_IMAGE'
export const RESET_AREA_FILTERS = 'app/RESET_AREA_FILTERS'
export const RESET_KIND_FILTERS = 'app/RESET_KIND_FILTERS'

export const SET_CURSOR = 'app/SET_CURSOR'

// Projects
export const SET_PROJECTS_DATE = 'app/SET_PROJECTS_DATE'

const LANG = initLocale()

const initialState = {
	loaded : false,
	cardinal : 'N',
	loading : false,
	menuOpen : false,
	currentSection : '',
	previousSection : '',
	kindTitle : '',
	kindsFilters : [],
	areasFilters : [],
	// currentKind : false,
	entry : undefined,
	projectsDate : '2017',
	nextSection : false,
	lang : LANG,
	materialsGridActive : false,
	projectsGridActive : false,
	projectsViewMode : (!isTabletOrMobile() ? 'timeline' : 'areas'),
	currentTimeLineProjectIndex : 0,
	cursor : 'default',
	isOnSingle : false,
	kindFeaturedImagePath : '',
	compassHiddenOnMobile : false,
	singleLeaving : false,
	mapLeaving : false,
	ip : null
}

export default (state = initialState, action, root) => {

	switch (action.type) {
		
		case SET_PROJECTS_VIEW_MODE:
			return{
				...state,
				projectsViewMode : action.payload
			}
		
		case SINGLE_LEAVING:
			return{
				...state,
				singleLeaving : action.payload
			}

		case MAP_LEAVING:
			return{
				...state,
				mapLeaving : action.payload
			}
		
		case GET_IP:
			return{
				...state,
				ip : action.payload
			}
		
		
		case SET_CURSOR:
			return{
				...state,
				cursor : action.payload
			}
		
		case SET_CURRENT_TL_PROJECT_INDEX:
			return{
				...state,
				currentTimeLineProjectIndex : action.payload
			}

		case SET_MATERIALS_GRID_ACTIVE:
			return{
				...state,
				materialsGridActive : action.payload
			}
		
		
		case SET_PROJECTS_GRID_ACTIVE:
			return{
				...state,
				projectsGridActive : action.payload
			}

		case SET_LANG:
			return {
				...state,
				lang : action.payload
			}

		case TOGGLE_MENU:
			// alert('TOGGLEMENU')
			return{
				...state,
				menuOpen : !state.menuOpen
			}
		
		case APP_LOADED:
			// alert('LOADED')
			return{
				...state,
				loaded : true
			}
		
		case SET_LOADING:
			return{
				...state,
				loading : action.payload
			}
		
		case SET_KIND_FEATURED_IMAGE:
			return{
				...state,
				kindFeaturedImagePath : action.payload
			}

		case GET_PROJECTS_AREAS:
			let areas = [ ...action.payload	]
			let areasFilters = []

			areas.forEach( area => {
				areasFilters.push({
					active : true,
					_id : area._id,
					slug : area.slug,
					name : area.name,
					name_en : area.name_en,
				})
			})

			return{
				...state,
				areasFilters
			}
		
		case GET_MATERIALS_KINDS:
			let kinds = [ ...action.payload	]
			let kindsFilters = []

			kinds.forEach( kind => {
				kindsFilters.push({
					active : true,
					_id : kind._id,
					slug : kind.slug,
					name : kind.name,
					name_en : kind.name_en,
				})
			})

			return{
				...state,
				kindsFilters
			}

		case SET_PROJECTS_DATE:
			if ( state.projectsDate !== action.payload ){
				return{
					...state,
					projectsDate : action.payload
				}
			}else{
				return state
			}
		
		case SET_KIND_TITLE:
		
			return{
				...state,
				kindTitle : action.payload
			}
			
		case TOGGLE_KIND_FILTER:
			let filters = [ ...state.kindsFilters ]
			// console.log(filters)
			filters.forEach( filter => {
					filter.active = filter.slug === action.payload ? !filter.active : filter.active
			})
			return{
				...state,
				kindsFilters : filters
			}
		
		case TOGGLE_AREA_FILTER:
			let filters_area = [ ...state.areasFilters ]
			// console.log(filters)
			filters_area.forEach( filter => {
					filter.active = filter.slug === action.payload ? !filter.active : filter.active
			})
			return{
				...state,
				areasFilters : filters_area
			}
		
		case RESET_AREA_FILTERS:
			let filters_area_bis = [ ...state.areasFilters ]
			filters_area_bis.forEach( filter => {
				filter.active = true
			})
			return{
				...state,
				areasFilters : filters_area_bis
			}

		case RESET_KIND_FILTERS:
			let filters_kind = [ ...state.kindsFilters ]
			// console.log(filters)
			filters_kind.forEach( filter => {
				filter.active = true
			})
			return{
				...state,
				kindsFilters : filters_kind
			}
		
		// case SET_MATERIAUTHEQUE_PROGRESS:
		// 	// alert('TOGGLEMENU')
		// 	return{
		// 		...state,
		// 		materiauthequeProgress : action.payload
		// 	}

		case SET_COMPASS:
			// console.log('set : ', action.payload)
			return {
				...state,
				cardinal: action.payload
			}
		
		case SET_COMPASS_HIDDEN_ON_MOBILE:
			
			return {
				...state,
				compassHiddenOnMobile : action.payload
			}
		
		case TOGGLE_LOADING:
			
			return {
				...state,
				loading: !state.loading
			}
		
		case SET_SECTION:
            // alert('SET_SECTION')
            return {
				...state,
				// cardinal: getCardinal(action.payload),
                currentSection: action.payload,
                previousSection: state.currentSection
            }
		
		case SET_NEXT_SECTION:
			// console.log(action.payload)
            return {
				...state,
				nextSection : action.payload,
            }
            
		case LOCATION_CHANGE:
            
				const path = action.payload.pathname	
				let sectionSlug = ( path === '/' ) ? 'accueil' : path.split('/')[1]
				let isOnSingle = path.split('/')[2] !== undefined
                return {
					...state,
                    currentSection: sectionSlug,
					previousSection: state.currentSection,
					isOnSingle : isOnSingle

                }
				
		default:
			return state
	}
}


/*
/*
/*        A C T I O N S
/*
/*
*/

export const setNextSection = (route) => {

	return dispatch => {
		
		dispatch({
			type: SET_NEXT_SECTION,
			payload: route,
		})
	
	}
}

export const setKindFeaturedImagePath = (path) => {
	
	return dispatch => {
		
		dispatch({
			type: SET_KIND_FEATURED_IMAGE,
			payload: path,
		})
	
	}
}

export const setCursor = (string) => {

	return dispatch => {
		
		dispatch({
			type: SET_CURSOR,
			payload: string,
		})
	
	}
}

export const getIP = () => {

	return dispatch => {
        
        axios.request({
            method: 'get',
            url: `https://api.ipify.org`
        })
        .then((result) => {
            dispatch({ type:GET_IP , payload:result.data });
        });

	}

}

export const setCurrentTimelineProjectIndex = (index) => {
	// console.log(index)

	return dispatch => {
		
		dispatch({
			type: SET_CURRENT_TL_PROJECT_INDEX,
			payload: index,
		})
	
	}
}

export const setProjectsViewMode = (mode) => {

	return dispatch => {
		
		dispatch({
			type: SET_PROJECTS_VIEW_MODE,
			payload: mode,
		})
	
	}
}

export const setMaterialsGridActive = (bool) => {

	return dispatch => {
		
		dispatch({
			type: SET_MATERIALS_GRID_ACTIVE,
			payload: bool,
		})
	
	}
}

export const setProjectsGridActive = (bool) => {

	return dispatch => {
		
		dispatch({
			type: SET_PROJECTS_GRID_ACTIVE,
			payload: bool,
		})
	
	}
}

export const setCompass = (cardinal) => {
	// console.log(cardinal)
	return dispatch => {
		
		dispatch({
			type: SET_COMPASS,
			payload: cardinal,
		})

	}

}

export const setCompassHiddenOnMobile = (bool) => {
	
	return dispatch => {
		
		dispatch({
			type: SET_COMPASS_HIDDEN_ON_MOBILE,
			payload: bool,
		})

	}

}

export const setLanguage = (iso) => {
	
	return dispatch => {
		
		dispatch({
			type: SET_LANG,
			payload: iso,
		})

	}

}

export const setKindTitle = (title) => {
	
	// console.log(progress)
	return dispatch => {
		dispatch({
			type: SET_KIND_TITLE,
			payload: title,
		})

	}

}

export const setProjectsDate = (year) => {
	
	// console.log(year)
	return dispatch => {
		dispatch({
			type: SET_PROJECTS_DATE,
			payload: year,
		})
	}

}

export const setLoading = (bool) => {
	
	// console.log(year)
	return dispatch => {
		dispatch({
			type: SET_LOADING,
			payload: bool,
		})
	}

}


export const setAppLoaded = () => {
	
	return dispatch => {
		dispatch({
			type: APP_LOADED,
		})
	}

}

export const singleLeaving = (bool) => {
	
	return dispatch => {
		dispatch({
			type: SINGLE_LEAVING,
			payload : bool
		})
	}

}

export const mapLeaving = (bool) => {
	
	return dispatch => {
		dispatch({
			type: MAP_LEAVING,
			payload : bool
		})
	}

}

export const toggleKindFilter = (slug) => {
	
	return dispatch => {
		dispatch({
			type: TOGGLE_KIND_FILTER,
			payload: slug,
		})
	}

}
export const resetKindFilters = (slug) => {
	
	return dispatch => {
		dispatch({
			type: RESET_KIND_FILTERS
		})
	}

}
export const resetAreaFilters = (slug) => {
	
	return dispatch => {
		dispatch({
			type: RESET_AREA_FILTERS
		})
	}

}

export const toggleAreaFilter = (slug) => {
	
	return dispatch => {
		dispatch({
			type: TOGGLE_AREA_FILTER,
			payload: slug,
		})
	}

}


export const setSection = (name) => {
	
	return dispatch => {
		
		dispatch({
			type: SET_SECTION,
			payload: name,
		})

	}

}

export const toggleLoading = () => {
	
	return dispatch => {
		
		dispatch({
			type: TOGGLE_LOADING
		})

	}

}

export const toggleMenu = () => {
	
	return dispatch => {
		
		dispatch({
			type: TOGGLE_MENU
		})

	}

}

// export const togglePoint = (name) => {
	
// 	return dispatch => {
// 		dispatch({
// 			type: 'app/TOGGLE_' + name.toUpperCase(),
// 		})
// 	}
// }



// WEBPACK FOOTER //
// ./src/behaviors/app.js